













































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Video from "@/components/Video.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    Video,
    NextPrevBtn,
    Footer,
  },
})
export default class MeetingTips extends Vue {
    protected videoMeetingTips = [
    {
      videoSrc: "https://www.youtube.com/embed/3w8lmzfGqQE",
      videoTitle: "Comment animer efficacement une réunion ? 1",
      videoRoot: "Chaîne :  Breasy : Et si manager devenait un jeu d'enfants ?",
    },
    {
      videoSrc: "https://www.youtube.com/embed/kBSHSZiS9uk",
      videoTitle: "Comment animer efficacement une réunion ? 2",
      videoRoot: "Chaîne : L'Express",
    },
  
    {
      videoSrc: "https://www.youtube.com/embed/jffoiI3ETr4",
      videoTitle: "Réunion de travail : interview d’un directeur qui a réussi à transformer ses séances.",
      videoRoot: "Chaîne : Organisologie",
    },

  ];
  protected nxtprevMeetingTips =
{
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail5.png",
    NextImage: "",
    PrevLink: "/Conduite_Reunion/Fondamentaux",
    NextLink: "",
  };
}
